module.exports = __webpack_public_path__ + "assets/img/home-main-content-bg.2b68425c.png";